<template>
  <modal title="Invite User" size="xs" ref="modal">
    <account-loader :account-id="accountId" v-model="account" />
    <form v-if="account" class="q-gutter-md">
      <q-input label="First Name" v-model="firstName" outlined />
      <q-input label="Last Name" v-model="lastName" outlined />
      <q-input label="Email" type="email" v-model="email" outlined />
      <select-role
        :account-type="account.type"
        v-model="roleId"
        :exclude="['SUPER_ADMIN']"
        outlined
      />
    </form>
    <template v-slot:actions>
      <async-btn
        label="Invite"
        color="primary"
        :task="task"
        :disable="!canAdd"
        @click="invite" />
    </template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import { User, Modal as ModalElement } from '@/type';
import Modal from '@/components/modal/Modal.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import notify from '@/components/notify';
import AccountLoader from '@/iam/account/AccountLoader.vue';
import { Account } from '@/iam/types';
import SelectRole from '@/role/SelectRole.vue';
import { invite } from './user';

interface Data {
  account: Account|null,
  firstName: string,
  lastName: string,
  email: string,
  roleId: number|null,
  task: Promise<User>|null
}

export default defineComponent({
  emits: ['ok'],
  mixins: [ModalMixin],
  components: {
    AccountLoader,
    Modal,
    SelectRole,
    AsyncBtn,
  },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      account: null,
      firstName: '',
      lastName: '',
      email: '',
      roleId: null,
      task: null,
    };
  },
  computed: {
    canAdd(): boolean {
      return (
        this.firstName !== '' && this.lastName !== ''
        && this.email !== '' && this.roleId !== null
      );
    },
  },
  methods: {
    invite() {
      if (!this.roleId) return;
      this.task = invite(this.accountId, this.firstName, this.lastName, this.email, this.roleId);
      this.task.then((user: User) => {
        this.$emit('ok', user);
        (this.$refs.modal as ModalElement).hide();
        notify(`Invitation sent to ${user.firstName} ${user.lastName}.`);
      });
    },
  },
});
</script>
